var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mainAuxPage zj-flex-column" },
    [
      _c("zj-card", { staticClass: "pageheader", attrs: { block: "" } }, [
        _c("div", { staticClass: "zj-flex-row" }, [
          _c(
            "div",
            { staticClass: "left-content" },
            [
              _c("el-avatar", { attrs: { size: 45 } }, [
                _vm._v(_vm._s(_vm.CurrentAccountInfo.emp_name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content-msg" }, [
                4 <= _vm.currentDate.getHours() &&
                _vm.currentDate.getHours() < 9
                  ? _c("div", { staticClass: "msg" }, [
                      _vm._v("\n            用心把握每一环节"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                9 <= _vm.currentDate.getHours() &&
                _vm.currentDate.getHours() < 12
                  ? _c("div", { staticClass: "msg" }, [
                      _vm._v(
                        "\n            早上好，" +
                          _vm._s(_vm.CurrentAccountInfo.emp_name) +
                          "，欢迎您使用数智IE服务系统！"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                12 <= _vm.currentDate.getHours() &&
                _vm.currentDate.getHours() < 18
                  ? _c("div", { staticClass: "msg" }, [
                      _vm._v(
                        "\n            下午好，" +
                          _vm._s(_vm.CurrentAccountInfo.emp_name) +
                          "，欢迎您使用数智IE服务系统！"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                18 <= _vm.currentDate.getHours() &&
                _vm.currentDate.getHours() < 22
                  ? _c("div", { staticClass: "msg" }, [
                      _vm._v(
                        "\n            晚上好，" +
                          _vm._s(_vm.CurrentAccountInfo.emp_name) +
                          "，欢迎您使用数智IE服务系统！"
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                22 <= _vm.currentDate.getHours() ||
                _vm.currentDate.getHours() < 4
                  ? _c("div", { staticClass: "msg" }, [
                      _vm._v(
                        "\n            夜深了，" +
                          _vm._s(_vm.CurrentAccountInfo.emp_name) +
                          "，欢迎您使用数智IE服务系统，早点休息！"
                      ),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "right-content" }, [
            _c("div", { staticClass: "content-item" }, [
              _c(
                "div",
                {
                  staticClass: "title",
                  staticStyle: { color: "red", "font-size": "22px" },
                },
                [_vm._v(" 学而不知足，自强而争先")]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "zj-flex-row" },
        [
          _c(
            "div",
            { staticClass: "zj-flex-column", staticStyle: { flex: "0.25" } },
            [
              _c("zj-card", { staticClass: "projectDiv" }, [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        flex: "1",
                        "flex-direction": "row",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [_c("div", [_vm._v("热点通知")])]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.notificationShow
                  ? _c(
                      "div",
                      { ref: "projectTable", staticClass: "zj-flex-column" },
                      [
                        _vm._l(_vm.notificationData, function (item, index) {
                          return _c(
                            "div",
                            {
                              attrs: { draggable: true },
                              on: {
                                dragstart: function ($event) {
                                  return _vm.dragstart(index)
                                },
                                dragenter: function ($event) {
                                  return _vm.dragenter($event, index)
                                },
                                dragover: function ($event) {
                                  return _vm.dragover($event, index)
                                },
                                click: function ($event) {
                                  return _vm.addOrEdit(0, item)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "projectCard",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openWindow(
                                        item.notification_link
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "projectCardHead" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-right": "5px",
                                            display: "-webkit-box",
                                            "font-size": "19px",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.notification_head))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c("div", { staticClass: "rightTable" }, [
                                        _c(
                                          "table",
                                          {
                                            staticStyle: {
                                              "font-size": "13px",
                                              width: "100%",
                                            },
                                          },
                                          _vm._l(item.line, function (lineNum) {
                                            return _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex",
                                                    flex: "1",
                                                    "flex-direction": "row",
                                                    "flex-wrap": "wrap",
                                                  },
                                                },
                                                _vm._l(
                                                  item.content,
                                                  function (subItem) {
                                                    return _c("div", [
                                                      subItem.nc_line == lineNum
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "10px",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "tr",
                                                                {
                                                                  attrs: {
                                                                    height:
                                                                      "30px;",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "th",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "auto",
                                                                          "white-space":
                                                                            "nowrap",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          subItem.nc_title
                                                                        ) + "："
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("td", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        subItem.nc_content
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ])
                                                  }
                                                ),
                                                0
                                              ),
                                            ])
                                          }),
                                          0
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c("div"),
                      ],
                      2
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "zj-flex-column" }, [
            _c("div", { staticClass: "zj-flex-column" }, [
              _c(
                "div",
                { staticClass: "reachPanel zj-flex-row" },
                [
                  _c(
                    "zj-card",
                    { staticStyle: { flex: "1", "margin-right": "5px" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("span", [_vm._v("赛事大厅")]),
                          _vm._v(" "),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                size: "small",
                                placeholder: "请输入大赛名称",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.refreshGame.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.model,
                                callback: function ($$v) {
                                  _vm.model = $$v
                                },
                                expression: "model",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.refreshGame },
                                  slot: "append",
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.refreshGame },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-right",
                              title: "查看详情",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changRouter(
                                  "competition/gameRegistration"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "zj-table",
                        {
                          ref: "projectTable",
                          attrs: {
                            data: _vm.tableData,
                            "row-key": "project_id",
                            border: "",
                            "tooltip-effect": "dark",
                            stripe: "",
                            "highlight-current-row": "",
                            height: "100%",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              width: "35",
                              align: "center",
                              label: "序号",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "p_name",
                              label: "大赛名称",
                              align: "center",
                              width: "200",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "报名开始日期",
                              prop: "competition_startdate",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_startdate
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "报名结束日期",
                              prop: "competition_enddate",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("dateFilter")(
                                          scope.row.competition_enddate
                                        )
                                      )
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "p_status",
                              label: "大赛进程",
                              align: "center",
                              sortable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    new Date(
                                      scope.row.competition_startdate
                                    ).getTime() > new Date().getTime()
                                      ? _c("div", { staticClass: "process1" }, [
                                          _vm._v(
                                            "\n                    未开始\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    new Date(
                                      scope.row.competition_startdate
                                    ).getTime() < new Date().getTime() &&
                                    new Date(
                                      scope.row.competition_enddate
                                    ).getTime() > new Date().getTime()
                                      ? _c("div", { staticClass: "process2" }, [
                                          _vm._v(
                                            "\n                    正在报名\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    new Date(
                                      scope.row.competition_enddate
                                    ).getTime() < new Date().getTime()
                                      ? _c("div", { staticClass: "process3" }, [
                                          _vm._v(
                                            "\n                    报名截止\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "zj-card",
                    { staticStyle: { flex: "1", "margin-right": "5px" } },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("span", [_vm._v("我的比赛")]),
                          _vm._v(" "),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                size: "small",
                                placeholder: "请输入大赛名称",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.searchData.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.condition,
                                callback: function ($$v) {
                                  _vm.condition = $$v
                                },
                                expression: "condition",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.searchData },
                                  slot: "append",
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.searchData },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-right",
                              title: "查看详情",
                              size: "mini",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changRouter(
                                  "competition/resultQuery"
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "zj-table-ct" },
                        [
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.tabelDatas,
                                border: "",
                                "tooltip-effect": "dark",
                                "highlight-current-row": "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  type: "index",
                                  width: "35",
                                  align: "center",
                                  label: "序号",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "p_name",
                                  label: "大赛名称",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ct_code",
                                  label: "队伍编号",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ct_name",
                                  label: "队伍名称",
                                  align: "center",
                                },
                              }),
                              _vm._v(" "),
                              _c("zj-table-column", {
                                attrs: {
                                  prop: "ct_stage",
                                  label: "当前状态",
                                  align: "center",
                                  width: "80",
                                  dict: _vm.dict,
                                },
                              }),
                              _vm._v(" "),
                              _c("zj-table-column", {
                                attrs: {
                                  prop: "ct_grade",
                                  label: "荣获奖项",
                                  align: "center",
                                  width: "80",
                                  dict: _vm.dict,
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "chartPanel zj-flex-row",
                  staticStyle: { height: "100px" },
                },
                [
                  _c(
                    "zj-card",
                    {
                      staticStyle: {
                        flex: "1",
                        "margin-top": "5px",
                        "margin-right": "5px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("span", [_vm._v("我的课程")]),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.getcourse },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-right",
                              title: "请打开知学习小程序查看",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.open },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "zj-table",
                        {
                          attrs: {
                            data: _vm.courseDatas,
                            border: "",
                            "tooltip-effect": "dark",
                            "highlight-current-ro": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "index",
                              width: "35",
                              align: "center",
                              label: "序号",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "p_no",
                              label: "课程编号",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "p_name",
                              label: "课程名称",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "emp_name",
                              label: "课程老师",
                              align: "center",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "zj-card",
                    {
                      staticStyle: {
                        flex: "1",
                        "margin-top": "5px",
                        "margin-right": "5px",
                      },
                    },
                    [
                      _c(
                        "div",
                        { attrs: { slot: "header" }, slot: "header" },
                        [
                          _c("span", [_vm._v("课程签到")]),
                          _vm._v(" "),
                          _c(
                            "el-input",
                            {
                              staticStyle: { width: "300px" },
                              attrs: {
                                size: "small",
                                placeholder: "请输入课程名称",
                                clearable: "",
                              },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.getsign.apply(null, arguments)
                                },
                              },
                              model: {
                                value: _vm.sign,
                                callback: function ($$v) {
                                  _vm.sign = $$v
                                },
                                expression: "sign",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    slot: "append",
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  on: { click: _vm.getsign },
                                  slot: "append",
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-refresh",
                              title: "刷新",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.getsign },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            attrs: {
                              icon: "el-icon-right",
                              title: "请打开知学习小程序查看",
                              size: "mini",
                              circle: "",
                            },
                            on: { click: _vm.open },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "zj-table",
                        {
                          attrs: {
                            data: _vm.signDatas,
                            border: "",
                            "tooltip-effect": "dark",
                            "highlight-current-row": "",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "p_name",
                              label: "课程名称",
                              align: "center",
                              width: "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "pp_location",
                              label: "地点",
                              align: "center",
                              width: "100",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sp_startdt",
                              label: "签到开始时间",
                              align: "center",
                              sortable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("dateFilter")(
                                            scope.row.sp_startdt,
                                            "MM-dd HH:mm"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sp_enddt",
                              label: "签到结束时间",
                              align: "center",
                              sortable: "",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("dateFilter")(
                                            scope.row.sp_enddt,
                                            "MM-dd HH:mm"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                width: "450px",
                title: "二维码绑定",
                visible: _vm.qrVisible,
                "close-on-click-modal": false,
                "append-to-body": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.qrVisible = $event
                },
              },
            },
            [
              [
                _c("div", { staticStyle: { height: "400px" } }, [
                  _c("div", { staticClass: "image-div" }, [
                    _c("img", {
                      staticClass: "center-png",
                      attrs: { src: "assets/logo/logo_circle.png" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "qrcode-ct" }, [
                    _c(
                      "div",
                      { on: { click: _vm.getQrCodeByBind } },
                      [
                        _c("vue-qr", {
                          staticStyle: { border: "1px solid #eee" },
                          attrs: {
                            text: _vm.qr_src,
                            binarize: "",
                            size: 200,
                            margin: 10,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "qr-tip" }, [
                      _vm._v(_vm._s(_vm.qr_tip)),
                    ]),
                  ]),
                ]),
              ],
            ],
            2
          ),
          _vm._v(" "),
          _c("editNotifucation", {
            ref: "editNotifucation",
            attrs: { visible: _vm.editVisible, editType: _vm.editType },
            on: {
              "update:visible": function ($event) {
                _vm.editVisible = $event
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }